// Data Program Unggulan STIKES Baramuli
const programUnggulan = [
  {
    id: 1,
    nama: "Beasiswa Kartu Indonesia Pintar (KIP-Kuliah)",
    singkatan: "KIP-K",
    icon: "🎓",
    deskripsi: "Program beasiswa dari pemerintah untuk mahasiswa dari keluarga kurang mampu secara ekonomi namun memiliki potensi akademik yang baik.",
    manfaat: [
      "Bebas biaya pendaftaran",
      "Bebas biaya kuliah/UKT",
      "Bantuan biaya hidup Rp 700.000/bulan",
      "Bantuan biaya buku dan peralatan",
      "Berlaku hingga lulus tepat waktu"
    ],
    syarat: [
      "Lulusan SMA/SMK/MA/Sederajat tahun berjalan atau maksimal 2 tahun sebelumnya",
      "Memiliki Kartu Indonesia Pintar (KIP) atau terdaftar di DTKS",
      "Lulus seleksi masuk perguruan tinggi",
      "Memiliki potensi akademik yang baik",
      "Berasal dari keluarga kurang mampu secara ekonomi"
    ],
    warna: "#4CAF50"
  },
  {
    id: 2,
    nama: "Rekognisi Pembelajaran Lampau - Transfer",
    singkatan: "RPL Transfer",
    icon: "🔄",
    deskripsi: "Program yang mengakui capaian pembelajaran yang diperoleh dari pendidikan formal sebelumnya untuk melanjutkan ke jenjang yang lebih tinggi.",
    manfaat: [
      "Pengakuan SKS dari pendidikan sebelumnya",
      "Masa studi lebih singkat",
      "Biaya kuliah lebih efisien",
      "Fleksibilitas waktu belajar",
      "Dapat sambil bekerja"
    ],
    syarat: [
      "Memiliki ijazah D3 Keperawatan/Kebidanan dari institusi terakreditasi",
      "IPK minimal 2.50",
      "Memiliki STR yang masih berlaku",
      "Pengalaman kerja minimal 2 tahun (untuk beberapa program)",
      "Lulus tes masuk dan wawancara"
    ],
    warna: "#2196F3"
  },
  {
    id: 3,
    nama: "Rekognisi Pembelajaran Lampau - Perolehan",
    singkatan: "RPL Perolehan",
    icon: "📜",
    deskripsi: "Program yang mengakui capaian pembelajaran yang diperoleh dari pengalaman kerja dan/atau pelatihan untuk mendapatkan kualifikasi pendidikan.",
    manfaat: [
      "Pengakuan pengalaman kerja sebagai kredit akademik",
      "Tidak perlu mengulang materi yang sudah dikuasai",
      "Peningkatan kualifikasi tanpa meninggalkan pekerjaan",
      "Jadwal kuliah yang fleksibel",
      "Portofolio pengalaman diakui"
    ],
    syarat: [
      "Pengalaman kerja minimal 5 tahun di bidang kesehatan",
      "Memiliki sertifikat pelatihan/kompetensi yang relevan",
      "Lulus asesmen portofolio",
      "Rekomendasi dari tempat kerja",
      "Lulus uji kompetensi"
    ],
    warna: "#FF9800"
  }
];

export default programUnggulan;
